module.exports = __webpack_public_path__ + "static/media/0520-r-r.be8b6a71.png";